import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PensionContext } from '../../../contexts/pension-robot/PensionContext';
import { BackButton, NextButton } from './NavigationButtons';
import { CocktailWrapperScreen } from './CocktailWrapperScreen';
import { CurrencyFormGroup } from '../../general/form-inputs/CurrencyFormGroup';
import { SavingButtons } from './DialogueDataSaving/PensionProgressSaver';
import { MAX_MORE_PENSION_THAN_INCOME } from '../../../config/constants';
import { isPensionCalculatedTogether } from '../../../utils/functions';

export const ExpensesSection: React.FC<{}> = () => {
    const { t } = useTranslation('pension');
    const {
        parameters: { personalInfo },
    } = useContext(PensionContext);

    const isCalculatedTogether = isPensionCalculatedTogether(personalInfo);
    return (
        <>
            <CocktailWrapperScreen
                page={2}
                title={
                    isCalculatedTogether
                        ? t('pension-cocktail-fill-screen-costs-title-partner')
                        : t('pension-cocktail-fill-screen-costs-title')
                }
            >
                <ExpensesSectionInputs />
            </CocktailWrapperScreen>
        </>
    );
};

export const ExpensesSectionInputs: React.FC<{}> = () => {
    const { t } = useTranslation('pension');
    const {
        parameters: { personalInfo, expensesInfo },
        actions,
    } = useContext(PensionContext);

    const calculatedWithPartner = isPensionCalculatedTogether(personalInfo);

    const excessiveMorePensionThanIncome = () => {
        const selfIncome = personalInfo.self?.salary ?? 0;
        const partnerIncome = calculatedWithPartner ? personalInfo.partner?.salary ?? 0 : 0;
        const pensionIncomeGoal = expensesInfo?.goal ?? 0;
        return pensionIncomeGoal - (selfIncome + partnerIncome) >= MAX_MORE_PENSION_THAN_INCOME;
    };

    return (
        <>
            <CurrencyFormGroup
                className="mb-8 w-full"
                value={expensesInfo?.goal}
                title={{
                    label: calculatedWithPartner
                        ? t('pension-cocktail-fill-screen-expenses-goal-input-partner')
                        : t('pension-cocktail-fill-screen-expenses-goal-input'),
                }}
                currencyInputProps={{
                    placeholder: '€ ',
                }}
                onChange={(cents) => {
                    actions.setParameters({ expensesInfo: { goal: cents } });
                }}
            />
            {excessiveMorePensionThanIncome() && (
                <div className="shadow-lg-all-sides border-l-4 border-bnd-yellow max-w-3xl p-4 rounded-lg bg-white">
                    <Trans
                        t={t}
                        i18nKey={
                            calculatedWithPartner
                                ? 'pension-cocktail-fill-screen-expenses-high-with-partner'
                                : 'pension-cocktail-fill-screen-expenses-high'
                        }
                        values={{}}
                    >
                        ... <span className="font-medium"></span> ...
                    </Trans>
                </div>
            )}

            <div className="flex flex-row flex-wrap gap-4 items-start my-8">
                <BackButton />
                <NextButton nextPage="pension" isDisabled={!expensesInfo?.goal} />
            </div>
            <SavingButtons />
        </>
    );
};
